import { useRegions } from '@/services/api/hooks/region';
import { useMap } from '@/services/csv/useCSVService';
import { useMemo } from 'react';
import { Maps } from './enum';

export const useBuildFullRegionMap = () => {
  const [regions] = useRegions();
  const regionsMap = useMap(Maps.Regions);

  return useMemo(() => {
    return {
      ...regionsMap,
      ...regions.reduce((acc, m) => ({ ...acc, [m.code]: m.id }), {})
    } as { [key: string]: string };
  }, [regions, regionsMap]);
};
